import { supplierTypeList, orderApplyStatusList } from '../../components/componentsData';
export const fieldList = [
  {
    label: '申请企业',
    type: 'input',
    value: 'companyName'
  },
  {
    label: '申请状态',
    type: 'select',
    value: 'applyStatusList',
    list: 'orderApplyStatusList'
  },
  {
    label: '供应商类型',
    type: 'select',
    value: 'supplierType',
    list: 'supplierTypeList'
  },
  {
    label: '申请单号',
    type: 'input',
    value: 'applyCode'
  },
  {
    label: '申请日期',
    type: 'date',
    dateType: 'daterange',
    value: 'applyTime'
  }
];

export const listTypeInfo = {
  supplierTypeList,
  orderApplyStatusList
};

export const tableLabel = [
  {
    label: '申请单号',
    param: 'applyCode',
    align: 'center',
    minWidth: 110
  },
  {
    label: '申请企业',
    param: 'companyName',
    align: 'center',
    tooltip: true,
    minWidth: 140
  },
  {
    label: '供应商类型',
    param: 'supplierTypeDesc',
    align: 'center',
    minWidth: 110
  },
  {
    label: '申请日期',
    param: 'applyTime',
    align: 'center',
    minWidth: 140
  },
  {
    label: '申请人',
    param: 'applicant',
    align: 'center',
    minWidth: 110
  },
  {
    label: '联系方式',
    param: 'applicant',
    align: 'center',
    minWidth: 110
  },
  {
    label: '产品名称',
    param: 'applicant',
    align: 'center',
    minWidth: 110
  },
  {
    label: '状态',
    param: 'applyStatusDesc',
    align: 'center',
    minWidth: 110
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100
  }
];
